export default {
    i18n: {
        "Group": "Grupa",
        "Http": "HTTP",
        "day": "dan",
        "Device Information": "Informacije o uređaju",
        "handset": "Slusalica",
        "auto": "Auto",
        "bluetooth": "bluetooth",
        "Device Name": "Naziv uređaja",
        "Volume": "Glasnoca",
        "Access Denied.": "Pristup odbijen.",
        "tamperAlarm": "Alarm sabotaže",
        "Card": "Kartica",
        "Fingerprint": "Otisak prsta",
        "Date Time": "Datum Vrijeme",
        "name": "Ime",
        "minutes": "minute",
        "timezone": "vremenska zona",
        "Are you sure you want to delete this device?": "Jeste li sigurni da želite izbrisati ovaj uređaj?",
        "Attendance Point Name": "Naziv tačke prisustva",
        "Mac": "Mac",
        "confirmToDeleteIt?": "Potvrda za brisanje?",
        "captureLogs": "Spisak slika",
        "Doors": "Vrata",
        "All Doors": "Sva vrata",
        "Lock List": "Zaključaj listu",
        "Link Device Relay": "Link relej uređaja",
        "Added Successfully!": "Dodan je uspješno !",
        "When the lock is linked with a relay, the lock will be unlocked when relay is triggered.": "Kad je brava povezana relejom, brava će se otključati kada se pokrene relej .",
        "Adding...": "Dodavanje...",
        "Please try again 24 hours later.": "Pokušajte ponovo 24 sata kasnije.",
        "Action": "Akcija",
        "unlock": "Otkljucaj",
        "Address": "Adresa",
        "Owner": "Vlasnik",
        "Failed": "Neuspjesno",
        "Timeout": "Vrijeme je isteklo",
        "Response": "Odgovor",
        "caller": "Pozivatelj",
        "receiver": "Prijemnik",
        "doorLogs": "Spisak vrata",
        "callHistory": "Historija poziva",
        "UID": "UID",
        "Call Type": "Vrsta poziva",
        "Code": "Kodeks",
        "User": "Korisnik",
        "Device List": "Spisak uredjaja",
        "Model": "Model",
        "Time": "Vrijeme",
        "Company": "Kompanija",
        "Property Managers": "Upravitelji Nekretninom",
        "Current Version": "Trenutna verzija",
        "indoorMonitor": "Zatvoreni monitor",
        "guardPhone": "Telefon portira ",
        "close": "Zatvoriti",
        "Success": "Uspjesno",
        "URL": "URL",
        "Please select a device.": "Molimo izaberite uredjaj.",
        "Password is too weak.": "Lozinka je preslaba.",
        "Company is required.": "Potrebno je unijeti kompaniju.",
        "Your account is not activated, please contact your service provider.": "Vas nalog nije aktiviran, molimo kontaktirajte Vaseg pruzaoca usluga.",
        "Language": "Jezik",
        "Face": "Lice",
        "Please set at least one access type.": "Molimo postavite barem jedan tip pristupa.",
        "Please contact your service provider to activate this advanced feature.": "Molimo kontaktirajte svog davatelja usluga da biste aktivirali ovu naprednu funkciju.",
        "Community name": "Naziv zajednice",
        "Please enable PM App first.": "Molimo omogućite prvo PM aplikaciju.",
        "Username": "Korisnicko ime",
        "Change Log": "Promijenite dnevnik",
        "Assign": "Dodijeliti",
        "Floor": "Sprat",
        "Link Device": "Link uređaj",
        "Accessible Floors": "Pristupni podovi",
        "Upgrade": "Nadogradnja",
        "Function": "Funkcija",
        "callDuration": "Trajanje poziva",
        "No": "Ne",
        "Verification Code": "Verifikacijski Kod",
        "Expiration Time": "Vrijeme isteka",
        "PIN": "Pin",
        "MAC": "MAC",
        "Building": "Zgrada",
        "APT": "Apt",
        "ID": "ID",
        "Name": "Ime",
        "activities": "Aktivnosti",
        "Obtain": "Dobiti",
        "call": "Poziv",
        "Group Call": "Grupni poziv",
        "Delete": "Izbrisi",
        "Yes": "Da",
        "Door Release PIN": "PIN za otkljucavanje vrata",
        "Email": "E-pošta",
        "Mobile Number doesn\'t exist.": "Broj mobitela ne postoji.",
        "Tips": "Savjeti",
        "Password": "Sifra",
        "The end time cannot be earlier than the start time.": "Vrijeme na kraju ne moze biti ranije od vremena na pocetku.",
        "Back": "Nazad",
        "File format error.": "Greška formata datoteke.",
        "motionDetection": "Detekcija kretnje",
        "You are trying too often, please try again in 5 minutes": "Pokusavate previse puta, molimo pokusajte ponovo za 5 minuta",
        "User name too long.": "Korisničko ime predugo.",
        "This MAC address is redirected on RPS.": "Ova MAC adresa je preusmjereno preko RPS-a.",
        "No Answer": "Nema odgovora",
        "failedToUnlock": "Otkljucavanje neuspjesno",
        "visitor": "posjetioc",
        "yesterday": "Jučer",
        "Too large data! Please first export the data before %s first,thanks.": "Prvo izvezite podatke prije %s, hvala.",
        "Please check if there is any unpaid orders, if not, please contact your service provider.": "Molimo provjerite ima li neplaćenih narudžbi, ako ne, obratite se svom dobavljaču usluga",
        "lock": "Zatvori vrata",
        "open": "Otvoren",
        "The PersonalAccount is not active.": "PersonalAccount nije aktivan.",
        "You cannot link an account that already link other accounts.": "Ne možete povezati račun koji već povezuje druge račune.",
        "You cannot link multiple property manager accounts under the same installer account.": "Ne možete povezati više računa vozača nekretnina na istom instalacijskom računu.",
        "You cannot link to the currently logged in account.": "Ne možete se povezati sa trenutno prijavljenim računom.",
        "nfc": "NFC",
        "Delete Device": "Obriši uređaj",
        "date": "Datum",
        "Device deleted successfully": "Uređaj se uspešno izbrisan",
        "Failed to delete device": "Nije uspjelo izbrisati uređaj",
        "Are you sure you want to cancel?": "Jeste li sigurni da želite otkazati?",
        "Unlimited": "Neograničen",
        "Battery Level": "Nivo baterije",
        "Password Incorrect.": "Lozinka netačna.",
        "deliverySystemVerification": "Provjera sistema isporuke",
        "Upgrading...": "Nadograđivanje...",
        "amenityReservation": "Pogodnost rezervacija",
        "idAccess": "ID pristup",
        "RF Card": "RF kartica",
        "exitButton": "Dugme za izlaz",
        "Please select at least one item.": "Odaberite najmanje jednu stavku.",
        "The ID can contain only digits and letters, up to 32 characters.": "ID može sadržavati samo brojeve i slova, do 32 znaka.",
        "The PIN is not available.": "PIN nije dostupan.",
        "Change WiFi": "Promijeni WiFi",
        "Phone number": "Broj telefona",
        "Invalid {0}.": "Nevažeći {0}.",
        "{0} already exists.": "{0} već postoji.",
        "Operation failed!": "Operacija nije uspjela!",
        "Failed to get data.": "Nije uspjelo preuzimanje podataka.",
        "You do not have the necessary permissions to perform this operation.": "Nemate potrebne dozvole za izvođenje ove operacije.",
        "You can only import one template at a time in the current site.": "Možete uvesti samo jedan predložak u isto vrijeme na trenutnoj stranici.",
        "Delivery name": "Naziv ovlaštenja dostave",
        "MAC address not in the MAC library.": "MAC adresa nije u MAC biblioteci.",
        "Please delete devices under this building.": "Molimo izbrišite uređaje ispod ove zgrade.",
        "The start time cannot be later than the end time.": "Vrijeme početka ne može biti kasnije od vremena završetka.",
        "emergency action type": "tip hitne akcije",
        "Only 1000 data items can be imported at a time.": "Istovremeno se može uvesti samo 1000 podataka.",
        "The password is too short.": "Lozinka je prekratka.",
        "The data has been updated. Please refresh the page and try again.": "Podaci su ažurirani. Molimo osvježite stranicu i pokušajte ponovo.",
        "AutoP length must be less 2048 bytes.": "Dužina AutoP mora biti manja od 2048 bajta.",
        "File Check Failed": "Provjera datoteke nije uspjela",
        "administratorAccountLoginHasExpired.PleaseContactYourServiceProvider.": "Prijava administrativnog naloga je istekla. Kontaktirajte pružatelja usluga.",
        "iqPinVerificationFailed": "IQ PIN provjera nije uspjela.",
        "accountBlacklisted": "Nalog je na crnoj listi.",
        "outsideAuthorizedTime": "Izvan ovlaštenog vremena.",
        "network group": "mrežna grupa",
        "Company name": "Naziv kompanije",
        "Group name": "Naziv grupe",
        "relay": "relej",
        "motionTime": "vrijeme detekcije pokreta",
        "motionType": "tipKretanja",
        "postalCode": "poštanski broj",
        "floor format": "format poda",
        "mobilePhone": "broj mobitela",
        "time format": "format vremena",
        "security relay": "sigurnosni relej",
        "Param": "Parametar",
        "Offline Code": "Vanmrežni kod",
        "Add akubela Smart Locks": "Dodaj akubela pametne brave",
        "Module Version": "Verzija modula",
        "Lock Body Version": "Verzija brave",
        "Available Version": "Dostupna verzija",
        "Please wake up the lock screen and then upgrade.": "Molimo probudite zaključani ekran pa zatim nadogradite.",
        "This process will take some time, please be patient.": "Ovaj proces može potrajati, molimo za strpljenje.",
        "Please confirm that the WiFi network is functioning properly.": "Molimo potvrdite da WiFi mreža radi ispravno.",
        "Please wake up the lock screen.": "Molimo probudite zaključani ekran.",
        "This lock has already been added to another apartment.": "Ova brava je već dodana drugom stanu.",
        "This lock has already been added to the apartment.": "Ova brava je već dodana u stan.",
        "Pin Code": "PIN kod",
        "Too many failed attempts, please try again in a few minutes.": "Previše neuspjelih pokušaja, pokušajte ponovo za nekoliko minuta.",
        "Login Account": "Prijava na račun",
        "Same account cannot login in different ins.": "Isti račun se ne može prijaviti na različite instalatere.",
        "Lock Name": "Ime brave",
        "Smart Locks": "Pametne brave",
        "Add Smart Lock": "Dodaj pametnu bravu",
        "The selected duration cannot be more than one year.": "Odabrano trajanje ne može biti duže od jedne godine.",
        "The end time of the break time cannot be later than the end work time.": "Vrijeme završetka pauze ne može biti kasnije od vremena završetka rada.",
        "The start time of the break time cannot be earlier than the start work time.": "Vrijeme početka pauze ne može biti ranije od vremena početka rada.",
        "The end time of the valid check time cannot be earlier than the end work time.": "Vrijeme završetka važećeg vremena za prijavu ne može biti ranije od vremena završetka rada.",
        "The start time of the valid check time cannot be later than the start work time.": "Vrijeme početka važećeg vremena za provjeru ne može biti kasnije od vremena početka rada.",
        "Deleting failed. The timetable is used by a shift.": "Brisanje nije uspjelo. Raspored koristi jedna smjena.",
        "Deleting failed. The shift is in use.": "Brisanje nije uspjelo. Smjena se koristi.",
        "Deleting failed. The leave type is in use.": "Brisanje nije uspjelo. Tip odsustva se koristi.",
        "Valid time conflicts with an existing schedule.": "Važeće vrijeme je u sukobu s postojećim rasporedom.",
        "The timing for multiple schedules must not coincide.": "Vremena za više rasporeda ne smiju se poklapati.",
        "Attendance Log": "Evidencija prisustva",
        "Added Failed!": "Dodavanje nije uspjelo!",
        "Setting WiFi": "Podešavanje WiFi-a",
        "License Plate": "Registarska tablica",
        "key": "Lozinka",
        "IQ Offline.": "IQ izvan mreže.",
        "{0}Unlock": "{0} Otključaj",
        "automatically": "Automatski",
        "manually": "Ručno",
        "Video Storage": "Video pohrana",
        "Device(s) for Video Storage": "Uređaj(i) za skladištenje videa",
        "The amount of exported data is too large. Please export it in batches.": "Količina izvezeneih podataka je prevelika. Molimo vas da ih izvezete u serijama.",
        "Auto-record video when door unlocks": "Automatsko snimanje videa pri otključavanju vrata",
        "Auto-record video during calls": "Automatsko snimanje videa tokom poziva",
        "Manual video recording in monitoring": "Ručno snimanje videa tokom nadzora",
        "Saved for 30days/60days/90days": "Sačuvano 30 dana/60 dana/90 dana",
        "To subscribe, please contact your provider for activation.": "Za pretplatu kontaktirajte vašeg pružatelja usluga radi aktivacije.",
        "Saved for {0}days": "Sačuvano {0} dana",
        "Subscribed Plan": "Pretplaćeni plan",
        "Supported Devices: {0}": "Podržani uređaji: {0}",
        "{0}Lock": "{0} Zaključaj",
        "Video Saving": "Snimanje videa",
        "Download Completed!": "Preuzimanje završeno!",
        "Fail to download.": "Preuzimanje nije uspjelo.",
        "Deleting failed! The property manager has been bound to a RentManager Customer, you should delete it firstly.": "Brisanje nije uspjelo! Upravitelj nekretnine je povezan sa RentManager korisnikom, prvo ga trebate izbrisati.",
        "No log to be exported.": "Nema zapisa za izvoz.",
        "capture&Video": "Snimak & Video",
        "packageDetection": "Detekcija paketa",
        "Time format is invalid.": "Format vremena nije važeći.",
        "No permission to export logs of this type.": "Nemate dozvolu za izvoz logova ovog tipa.",
        "Project type is invalid.": "Tip projekta nije važeći.",
        "Salto Account Blocked.": "Salto račun je blokiran.",
        "Remote open not in access group.": "Daljinsko otvaranje nije dozvoljeno za ovu grupu pristupa.",
        "SIP Account required.": "SIP račun je obavezan.",
        "The PIN must be {0} digits.": "PIN mora imati {0} cifara.",
        "gatewayConnectionUnavailable": "Veza sa gateway uređajem nije dostupna.",
        "Invalid Username or Password": "Neispravno korisničko ime ili lozinka",
        "Account already linked to another user.": "Račun je već povezan s drugim korisnikom.",
        "The account has been added by another user.": "Račun je dodao drugi korisnik.",
        "Failed to add. This user already has 5 license plates.": "Dodavanje nije uspjelo. Ovaj korisnik već ima 5 registarskih tablica.",
        "Please at least select a door.": "Molimo da odaberete barem jedna vrata.",
        "UHF Card": "UHF kartica",
        "personnel": "osoblje",
        "Parking Lot Name": "Naziv parkinga",
        "Controlled Relay": "Kontrolirani relej",
        "No Permission": "Nema dozvole",
        "Please ensure that all doors in the project are activated at the same time.": "Molimo osigurajte da su sva vrata u projektu aktivirana u isto vrijeme.",
        "gatewayBusy": "Gateway je zauzet",
        "Please set the perimeter door group first.": "Molimo prvo postavite grupu perimetarskih vrata.",
        "Please ensure that all doors in the project are renewed at the same time.": "Molimo osigurajte da se sva vrata u projektu obnove u isto vrijeme.",
        "When lockdown is on, the controlled relay cannot be modified.": "Kada je zaključavanje uključeno, kontrolisani relej se ne može mijenjati.",
        "DetectionLogs": "Evidencija detekcija",
        "packageIn": "Paket je ubačen",
        "packageOut": "Paket je izvađen",
        "View Progress": "Prikaži napredak",
        "Check if the WiFi is operating on the 2.4GHz band.": "Provjerite da li WiFi radi na 2.4GHz frekvenciji.",
        "Verify that the WiFi password is correct.": "Provjerite da li je WiFi lozinka ispravna.",
        "Ensure that you are connected to the correct device hotspot during the hotspot configuration.": "Osigurajte da ste povezani na ispravan hotspot uređaja tokom konfiguracije hotspota.",
        "Offline Code Unlock": "Otključavanje offline kodom",
        "Salto Token Expired.": "Salto token je istekao.",
        "Lock Offline": "Brava van mreže",
        "identity information! Please login again": "Informacije o identitetu! Molimo prijavite se ponovo",
        "Email is required.": "Email je obavezan.",
        "Mobile number is required.": "Broj mobitela je obavezan.",
        "You can\'t make payments for offices in different time zones.": "Ne možete izvršiti plaćanja za kancelarije u različitim vremenskim zonama.",
        "The current scheduling staff exceeds 200 people.": "Trenutno osoblje za raspoređivanje prelazi 200 ljudi.",
        "param": "parametar",
        "Invalid UserName or Password": "Nevažeće korisničko ime ili lozinka",
        "Your Salto KS account does not have permission to modify the lock\'s name.": "Vaš Salto KS račun nema dozvolu za izmjenu imena brave.",
        "Owner is required.": "Vlasnik je potreban.",
        "Office is required.": "Potrebna je kancelarija.",
        "PIN or RF Card is required.": "Potreban je PIN ili RF kartica.",
        "RF card": "RF kartica",
        "Personnel is required.": "Potrebno je osoblje.",
        "email address": "email adresa",
        "mobile number": "broj mobitela",
        "The length must be less than 32 characters.": "Dužina mora biti manja od 32 znaka.",
        "The length must be less than 256 characters.": "Dužina mora biti manja od 256 znakova.",
        "Access Group is required.": "Potrebna je pristupna grupa.",
        "Device is required.": "Uređaj je potreban.",
        "Admin is required.": "Potreban je administrator.",
        "Mobile number": "Broj mobitela",
        "schedules": "rasporedi",
        "Timetable name": "Naziv rasporeda",
        "Shift name": "Naziv smjene",
        "Leave type": "Vrsta odsustva",
        "recheck in time": "ponovno vrijeme prijave",
        "recheck out time": "ponovno vrijeme odjave",
        "The building name": "Naziv zgrade",
        "Building is required.": "Zgrada je potrebna.",
        "selection, The same reader cannot be set for both entry and exit": "selekcija, Isti čitač ne može biti postavljen za ulaz i izlaz",
        "Door number": "Broj vrata",
        "door input cannot be selection duplicated.": "Ulaz za vrata ne može biti odabran više puta.",
        "Group is required.": "Grupa je obavezna.",
        "Title can contain up to 32 characters.": "Naslov može sadržavati do 32 znaka.",
        "Content can contain up to 1024 characters.": "Sadržaj može sadržavati do 1024 znaka.",
        "Content can contain up to 64 characters.": "Sadržaj može sadržavati do 64 znaka.",
        "Report is required.": "Izvještaj je potreban.",
        "ID is required.": "Potrebna je lična karta.",
        "The office does not exist.": "Kancelarija ne postoji.",
        "Office name": "Naziv ureda",
        "The Temp Key does not exist.": "Privremeni ključ ne postoji.",
        "autolock time": "vrijeme automatskog zaključavanja",
        "The User does not exist.": "Korisnik ne postoji.",
        "The Installer does not exist.": "Instalater ne postoji.",
        "The Project does not exist.": "Projekat ne postoji.",
        "The Distributor does not exist.": "Distributor ne postoji.",
        "The Community Device does not exist.": "Zajednički uređaj ne postoji.",
        "The Property Manager does not exist.": "Upravitelj nekretnine ne postoji.",
        "The Sub Distributor does not exist.": "Subdistributer ne postoji.",
        "The Single Slave does not exist.": "Jedinstveni korisnik ne postoji.",
        "The Property Manager EndUser does not exist.": "Krajnji korisnik upravitelja nekretninama ne postoji.",
        "The Family Member does not exist.": "Član porodice ne postoji.",
        "Set Failed!": "Postavljanje nije uspjelo!",
        "You have reached the limit of 10 access code requests within a 30-minute period. Please try again later.": "Dostigli ste ograničenje od 10 zahtjeva za pristupnim kodom u roku od 30 minuta. Molimo pokušajte ponovo kasnije.",
        "This Email doesn\'t exist.": "Ova e-mail adresa ne postoji.",
        "detection type": "tip detekcije",
        "Device UUID": "UUID uređaja",
        "smart lock device": "pametna brava",
        "You are trying too often, please try again in 5 minutes.": "Prečesto pokušavate, molimo pokušajte ponovo za 5 minuta.",
        "You can only import one file at a time. Please wait for the current import to finish.": "Možete uvesti samo jednu datoteku u isto vrijeme. Molimo sačekajte da trenutni uvoz završi.",
        "NVR Name": "Naziv NVR-a",
        "NVR Address": "Adresa NVR-a",
        "Stay Alarm": "Alarm za duži boravak",
        "Happended On": "Dogodilo se",
        "Edit Milesight NVR": "Uredi Milesight NVR",
        "Add Milesight NVR": "Dodaj Milesight NVR",
        "Auto-record video on motion detection, package detection": "Automatsko snimanje videa pri detekciji pokreta ili paketa",
        "A 7-day free trial is included with your subscription.": "Vaša pretplata uključuje besplatni probni period od 7 dana.",
        "For service renewal, please reach out to your provider.": "Za obnovu usluge kontaktirajte vašeg pružatelja usluga.",
        "Allow the Property Manager to view recorded videos": "Dozvolite upravitelju nekretnina da vidi snimljene video zapise",
        "Please ensure the WiFi network is working properly.": "Molimo osigurajte da WiFi mreža ispravno radi.",
        "Edit akubela Smart Locks": "Uredi akubela pametne brave",
        "Upgraded Successfully!": "Uspješno nadograđeno!",
        "Upgraded Failed!": "Nadogradnja nije uspjela!",
        "Editing...": "Uređivanje...",
        "Edited successfully!": "Uspješno uređeno!",
        "Edited Failed!": "Uređivanje nije uspjelo!",
        "Downloading video...": "Preuzimanje videa...",
        "All Locks": "Sve brave",
        "Select Locks": "Odaberite brave",
        "The {0} digits PIN can be used once the akubela smart lock is connected to the network. Please note that it may take a short time for the PIN to take effect after synchronization.": "{0}-cifreni PIN se može koristiti kada je akubela pametna brava povezana na mrežu. Imajte na umu da može potrajati kratko vrijeme da PIN postane aktivan nakon sinhronizacije.",
        "Please at least select a door or a lock.": "Molimo da odaberete barem jedna vrata ili jednu bravu.",
        "This lock has already been added to your apartment.": "Ova brava je već dodana u vaš stan.",
        "This lock has already been added to another apartment, please contact your service provider for assistance.": "Ova brava je već dodana u drugi stan, molimo kontaktirajte svog pružatelja usluga za pomoć.",
        "LockBody Version": "Verzija brave",
        "Two-factor Authentication": "Dvofaktorska autentikacija",
        "Monitoring Scope": "Opseg nadzora",
        "Stay Duration": "Trajanje boravka",
        "Volume Settings": "Postavke jačine zvuka",
        "get card list for lock error": "Greška prilikom dobivanja liste kartica za zaključavanje",
        "get card list parse fail": "Neuspješno parsiranje liste kartica",
        "get pin list for lock error": "Greška prilikom dobivanja liste PIN-ova za zaključavanje",
        "get pin list parse fail": "Neuspješno parsiranje liste PIN-ova",
        "fingerprint code must be less than 2048 characters or empty.": "Kod otiska prsta mora imati manje od 2048 karaktera ili biti prazan.",
        "Personnel not in office.": "Osoblje nije u uredu.",
        "customize form fail.": "Prilagođavanje obrasca nije uspjelo.",
        "smart lock type error.": "Greška u tipu pametne brave.",
        "invalid client id or secret": "Nevažeći ID klijenta ili tajni podatak",
        "invalid account or password": "Nevažeći račun ili lozinka",
        "invalid access token": "Nevažeći pristupni token",
        "invalid refresh token": "Nevažeći token za osvježenje",
        "no permission to access this project": "Nema dozvole za pristup ovom projektu",
        "Stay Alarm Time": "Vrijeme trajanja alarma",
        "This function only support sl20 lock.": "Ova funkcija podržava samo sl20 bravu.",
        "Json marshal error.": "Greška pri serijalizaciji Json-a.",
        "Json unmarshal error.": "Greška pri deserijalizaciji Json-a.",
        "Illegal request, not added within valid time.": "Nelegalan zahtjev, nije dodano u okviru važećeg vremena.",
        "invalid nvr type": "Nevažeći tip NVR-a",
        "project is empty": "Projekt je prazan",
        "project type is invalid": "Tip projekta je nevažeći",
        "owner is invalid": "Vlasnik je nevažeći",
        "url is invalid": "URL je nevažeći",
        "password is invalid": "Lozinka je nevažeća",
        "building is invalid": "Zgrada je nevažeća",
        "fail to get data": "Neuspješno preuzimanje podataka",
        "invalid allow pm view type": "Nevažeći tip dozvole za PM prikaz",
        "Data not exist.": "Podaci ne postoje.",
        "cannot find community PrivateKey.": "Nije moguće pronaći privatni ključ zajednice.",
        "cannot find single PrivateKey.": "Nije moguće pronaći pojedinačni privatni ključ.",
        "The third party not exist.": "Treća strana ne postoji.",
        "{0} and indoor monitors/guard phones": "{0} i unutarnji monitori/telefoni čuvara",
        "{0} and indoor monitors/guard phones, with phone as backup": "{0} i unutarnji monitori/telefoni čuvara, sa telefonom kao rezervom",
        "Indoor monitors/guard phones with {0} as backup": "Unutarnji monitori/telefoni čuvara sa {0} kao rezervom",
        "Indoor monitors/guard phones with {0} as backup, finally the phone": "Unutarnji monitori/telefoni čuvara sa {0} kao rezervom, na kraju telefon",
        "{0} Intercom Feature": "{0} funkcija interfona",
        "Capture on {0}": "Snimi na {0}",
        "{0} Intercom Feature is not activated or has expired.": "Interfonska funkcija {0} nije aktivirana ili je istekla.",
        "fingerprint code must be equal 1620 characters or empty.": "Kod otiska prsta mora imati tačno 1620 karaktera ili biti prazan.",
        "To ensure a successful upgrade, please make sure the lock\'s battery level is above 40% before proceeding.": "Za uspješnu nadogradnju, provjerite da nivo baterije na bravi bude iznad 40% prije nego nastavite.",
        "Automatic Locking Time": "Vrijeme automatskog zaključavanja",
        "WiFi Keep-Alive": "WiFi održavanje veze",
        "WiFi Setting": "WiFi podešavanje",
        "Connecting the network...": "Povezivanje na mrežu...",
        "Set successfully!": "Podešavanje uspješno!",
        "The offline code can be used even if the lock is not connected to WiFi.": "Offline kod može se koristiti čak i ako brava nije povezana na WiFi.",
        "Enabling this feature will increase the lock\'s power consumption.": "Aktiviranjem ove funkcije povećava se potrošnja energije brave.",
        "Each offline code can only be used once.": "Svaki offline kod može se koristiti samo jednom.",
        "Receiver Info": "Informacije o primaocu",
        "log id": "ID prijave",
        "Create HW SN Config Empty SN.": "Kreiraj HW SN konfiguraciju praznog SN-a.",
        "The SN": "Serijski broj",
        "SN can contain up to 32 characters.": "Serijski broj može sadržavati najviše 32 karaktera.",
        "Check HW SN Not Found.": "Provjeri HW SN nije pronađen.",
        "the end user not found": "Krajnji korisnik nije pronađen",
        "Family Call": "Porodični poziv",
        "During the upgrade, all lock-related functions will be temporarily unavailable.": "Tokom nadogradnje sve funkcije vezane za bravu će biti privremeno nedostupne.",
        "8-digit PIN code starting with \"9\" is invalid!": "8-cifreni PIN koji počinje s \"9\" je nevažeći!",
        "Lock name length must be between 1 and 50": "Dužina imena brave mora biti između 1 i 50.",
        "The number of personnel with landline service cannot exceed the number of those with {0} Intercom.": "Broj osoblja sa fiksnom telefonskom uslugom ne može biti veći od broja onih koji koriste {0} interfon.",
        "The number of admins with landline service cannot exceed the number of those with {0} Intercom.": "Broj administratora sa fiksnom telefonskom uslugom ne može biti veći od broja onih sa {0} Interkom uslugom.",
        "charge type": "vrsta naplate",
        "The number of personnel with landline service cannot exceed the number of those with SmartPlus Intercom.": "Broj osoblja s fiksnom telefonskom uslugom ne može premašiti broj onih sa SmartPlus interkom uslugom.",
        "The number of admins with landline service cannot exceed the number of those with SmartPlus Intercom.": "Broj administratora s fiksnom telefonskom uslugom ne može premašiti broj onih sa SmartPlus interkom uslugom.",
        "A reader cannot be configured to use both Wiegand and RS485 simultaneously.": "Čitač ne može biti konfigurisan za korištenje Wiegand-a i RS485 istovremeno.",
        "parameter error": "greška parametra",
        "community name already exist": "Naziv zajednice već postoji",
        "personnel app without intercom feature number": "aplikacija za osoblje bez broja funkcije interfona",
        "check feature billing charge plan new error": "provjeri novu grešku u planu naplate funkcije",
        "subscription not found": "Pretplata nije pronađena",
        "System setting record not found.": "Nije pronađen zapis o postavkama sistema.",
        "Smart home not enabled.": "Pametna kuća nije omogućena.",
        "the apt call type value is invalid.": "Vrijednost tipa apt poziva je nevažeća.",
        "the ip call or sip call value is invalid.": "Vrijednost IP poziva ili SIP poziva je nevažeća.",
        "pinCode must be 2-8 digit number, but cannot be an 8-digit number starting with 9 or empty.": "pinCode mora biti broj od 2 do 8 cifara, ali ne može biti 8-cifreni broj koji počinje sa 9 niti može biti prazan.",
        "rfCard must be A-F0-9 and less than 16 bits or empty.": "rfCard mora sadržavati samo znakove A-F0-9, biti kraći od 16 bitova ili biti prazan.",
        "owner cannot be empty.": "vlasnik ne može biti prazan.",
        "creator cannot be empty.": "Kreator ne može biti prazan.",
        "the creator type value is invalid": "Vrijednost tipa kreatora nije važeća",
        "the IsCreateByPm value is invalid": "Vrijednost IsCreateByPm je nevažeća",
        "the pinCode already exist": "PIN kod već postoji",
        "the rfCard already exist": "rfCard već postoji",
        "license plate is invalid.": "Registracijska tablica nije važeća.",
        "owner info is invalid.": "Informacije o vlasniku nisu važeće.",
        "uhf is invalid.": "uhf je nevažeći.",
        "time control is invalid.": "kontrola vremena nije važeća.",
        "You have reached the limit of 5 Vehicle License Plate and are not allowed to add": "Dostigli ste ograničenje od 5 registarskih tablica vozila i nije vam dozvoljeno dodati više.",
        "the plate already exist": "tablica već postoji",
        "the uhf already exist": "UHF već postoji.",
        "empty community": "prazna zajednica",
        "no find license Plate": "nije pronađena registarska tablica",
        "IDAccess mode must be 0, 1, or 2.": "IDAccess način mora biti 0, 1 ili 2.",
        "Run field is required when mode is 1 or 2.": "Polje za pokretanje je obavezno kada je režim 1 ili 2.",
        "Serial field is required when mode is 2.": "Serijsko polje je obavezno kada je način rada 2.",
        "the pin cannot be empty": "PIN ne može biti prazan",
        "the rfCard cannot be empty": "rfCard ne može biti prazan",
        "the IDAccess already exist": "IDAccess već postoji",
        "the resident cannot be empty": "stanar ne može biti prazan",
        "the fingerprint cannot be empty": "otisak prsta ne može biti prazan",
        "the face cannot be empty": "Lice ne može biti prazno",
        "not found pin": "nije pronađen pin",
        "not found rfCard": "rfKartica nije pronađena",
        "not found IDAccess": "IDAccess nije pronađen",
        "not found fingerprint": "otisak prsta nije pronađen",
        "not found face": "nije pronađeno lice",
        "face pic is invalid.": "Slika lica nije važeća.",
        "community build and room cannot be empty.": "Izgradnja zajednice i prostorija ne može biti prazna.",
        "device info mac cannot be empty.": "Informacije o uređaju MAC ne mogu biti prazne.",
        "scheduler type must be 0,1,2 or time format is invalid or dataflag not in 0-127.": "Tip raspoređivača mora biti 0, 1, 2 ili je format vremena nevažeći ili podatkovna zastavica nije u rasponu 0-127.",
        "MAC address cannot be empty.": "MAC adresa ne može biti prazna.",
        "MAC address 0C1105000000 is not allowed.": "MAC adresa 0C1105000000 nije dozvoljena.",
        "MAC address must be 12 hexadecimal characters.": "MAC adresa mora imati 12 heksadecimalnih znakova.",
        "Scheduler type value is invalid.": "Vrijednost tipa raspoređivača nije važeća.",
        "parse is fail": "parsiranje nije uspjelo",
        "the fingerprint already exist": "Otisak prsta već postoji",
        "the licensePlate cannot be empty": "registracijska tablica ne može biti prazna",
        "the licensePlate already exist": "Registarska tablica već postoji",
        "idaccess run must be 10 digit number or end with -K.": "idaccess mora biti broj od 10 cifara ili završavati sa -K.",
        "idaccess serial must be 9 digit number.": "idaccess serijski broj mora biti devetocifreni broj.",
        "relay not in 0-15": "Relej nije u rasponu 0-15",
        "security relay not in 0-3": "sigurnosni relej nije u 0-3",
        "file name is wrong": "Naziv datoteke je pogrešan",
        "access mode specified": "navedeni način pristupa",
        "create community user accessmode failed.": "kreiranje načina pristupa korisnika zajednice nije uspjelo.",
        "delete community user accessmode failed.": "Brisanje načina pristupa korisnika zajednice nije uspjelo.",
        "Cannot delete building because it has associated users.": "Nije moguće izbrisati zgradu jer ima povezane korisnike.",
        "Cannot delete building because it has associated Salto devices.": "Nije moguće izbrisati zgradu jer je povezana sa Salto uređajima.",
        "community building not found": "Zgrada zajednice nije pronađena",
        "Invalid Name Display": "Nevažeći prikaz imena",
        "The Community does not exist.": "Zajednica ne postoji.",
        "Update CommunityIsInstallerKit Error.": "Ažuriraj grešku CommunityIsInstallerKit.",
        "Dis Not SupportCommunityCalls Error.": "Greška: Agent ne podržava pozive zajednice.",
        "Community Has Special Device, Not Allowed To Delete.": "Zajednica ima poseban uređaj, nije dozvoljeno brisanje.",
        "The project smart home switch must be disabled": "Pametni prekidač za projekat mora biti onemogućen",
        "There are ITec Locks in project": "U projektu postoje ITec brave.",
        "There are Salto Locks in project": "U projektu postoje Salto brave.",
        "There are Dormakaba Locks in project": "U projektu postoje Dormakaba brave.",
        "It is rent manager project": "To je projekat Rent Manager.",
        "It is installer account": "To je instalaterski račun",
        "contact preference type": "tip preferencije kontakta",
        "Floor list is required when not all floors.": "Popis spratova je potreban kada nisu svi spratovi uključeni.",
        "Building floors list is required when all buildings.": "Popis spratova zgrada je potreban za sve zgrade.",
        "Indoor monitor name is required.": "Naziv unutrašnjeg monitora je obavezan.",
        "The primary account is not activated.": "Primarni račun nije aktiviran.",
        "You can\'t create more family member accounts.": "Ne možete kreirati više računa za članove porodice.",
        "community user not found": "Korisnik zajednice nije pronađen",
        "community is empty": "Zajednica je prazna",
        "the end user not master user": "krajnji korisnik nije glavni korisnik",
        "the end user not member user": "krajnji korisnik nije korisnik člana",
        "The email already exists and cannot be repeated": "Email već postoji i ne može se ponoviti",
        "The mobile Number already exists": "Broj mobitela već postoji",
        "The room number format error.": "Greška u formatu broja sobe.",
        "community not found": "Zajednica nije pronađena",
        "resident not found": "stanar nije pronađen",
        "installer not found": "Instalater nije pronađen",
        "Operation Failed!": "Operacija nije uspjela!",
        "You don\'t have operate permission": "Nemate dozvolu za rad",
        "You cannot select Relay and Door at the same time": "Ne možete istovremeno odabrati relej i vrata.",
        "user don\'t active": "korisnik nije aktivan",
        "User has expired": "Korisnik je istekao",
        "timestamp must be within 3 minutes of current server time": "Vremenska oznaka mora biti unutar 3 minute od trenutnog vremena servera.",
        "cannot find single rf Card.": "Ne mogu pronaći nijednu RF karticu.",
        "cannot find community rf Card.": "Nije moguće pronaći zajednicu rf karticu.",
        "smartLock model": "model pametne brave",
        "the project does not open smart home": "projekat ne otvara pametni dom",
        "php web server error": "greška PHP web servera",
        "Ins not found.": "Ins nije pronađen.",
        "RentManage Unit Not Set.": "RentManage jedinica nije postavljena.",
        "add audit log error": "dodaj grešku u revizijski zapisnik",
        "check building in error": "provjerite grešku u zgradi",
        "Special devices cannot be deleted": "Posebni uređaji se ne mogu izbrisati",
        "the email is empty": "Email je prazan.",
        "the email format is incorrect": "Format e-pošte nije ispravan",
        "the mobile number is empty": "Broj mobitela je prazan.",
        "the mobile number format is incorrect": "format broja mobilnog telefona nije tačan",
        "Site not found": "Stranica nije pronađena",
        "User not found": "Korisnik nije pronađen",
        "invalid time format": "Nevažeći format vremena",
        "ground floor type": "tip prizemlja",
        "Start floor range error, valid values are -10 to -1, G0, G1, G2, 1 to 128.": "Greška u rasponu početnog sprata, važeće vrijednosti su od -10 do -1, G0, G1, G2, od 1 do 128.",
        "Building ID must be between 1 and 99.": "ID zgrade mora biti između 1 i 99.",
        "Community building name": "Naziv zgrade zajednice",
        "Building ID already exists in this community.": "ID zgrade već postoji u ovoj zajednici.",
        "building ID": "ID zgrade",
        "Community building not found.": "Zgrada zajednice nije pronađena.",
        "Cannot delete building because it has associated devices.": "Ne možete izbrisati zgradu jer ima povezane uređaje.",
        "project is not valid": "projekt nije važeći",
        "Cannot delete building because it has associated salto devices.": "Nije moguće izbrisati zgradu jer ima povezane Salto uređaje.",
        "Cannot delete building because it has associated iTec devices.": "Ne može se izbrisati zgrada jer ima pridružene iTec uređaje.",
        "Cannot delete building because it has associated dormakaba devices.": "Nije moguće izbrisati zgradu jer ima povezane dormakaba uređaje.",
        "member limit num": "ograničenje broja članova",
        "Indoor Monitor No Set Error.": "Greška: Unutrašnji monitor nije postavljen.",
        "The room not has indoor": "Soba nema unutrašnji uređaj.",
        "check user in building error": "provjeri korisnika u grešci zgrade",
        "The name specified is already in use.": "Naziv koji ste naveli je već u upotrebi.",
        "This timeblock overlaps with an existing one. Please adjust it.": "Ovaj vremenski blok se preklapa sa postojećim. Molimo vas da ga prilagodite.",
        "This door status changed. Please try again.": "Status vrata je promijenjen. Molimo pokušajte ponovo.",
        "the lock can\'t bind this community": "Brava ne može vezati ovu zajednicu.",
        "The custom quantity limit has been exceeded!": "Premašeno je prilagođeno ograničenje količine!",
        "This time span overlaps with an existing one. Please adjust it.": "Ovaj vremenski raspon se preklapa s postojećim. Molimo prilagodite ga.",
        "This one time runs overlap with an existing one time runs effective time. Please adjust it.": "Ovaj jednokratni raspored se preklapa sa postojećim jednokratnim rasporedom. Molimo prilagodite ga.",
        "Operation Failed. Please try again.": "Operacija nije uspjela. Molimo pokušajte ponovo.",
        "The image is not a front view.": "Slika nije prikaz s prednje strane.",
        "A mask was detected.": "Maska je otkrivena.",
        "The image resolution is too low.": "Rezolucija slike je preniska.",
        "No face was detected.": "Nije otkriveno lice.",
        "The file size is too large.": "Veličina datoteke je prevelika.",
        "The face in the image is too large.": "Lice na slici je preveliko.",
        "The face in the image is too small.": "Lice na slici je previše malo.",
        "Multiple faces detected.": "Otkriveno je više lica.",
        "The face is not clear enough.": "Lice nije dovoljno jasno.",
        "Face detection failed.": "Prepoznavanje lica nije uspjelo.",
        "Please enter a value between 1 and 9999": "Molimo unesite vrijednost između 1 i 9999",
        "Please select which input your door sensor is connected to.": "Molimo odaberite na koji ulaz je povezan vaš senzor za vrata.",
        "Add temp key failed, please try it again": "Dodavanje privremenog ključa nije uspjelo, molimo pokušajte ponovo",
        "Dis Not Support Dynamic QRCode Error.": "Dis Ne Podržava Dinamički QRCode Grešku.",
        "QR code not exist": "QR kod ne postoji",
        "The temp key has expired.": "Privremeni ključ je istekao.",
        "The device is not in the office": "Uređaj nije u uredu",
        "The device is already assigned.": "Uređaj je već dodijeljen.",
        "The device cannot be assigned to any user.": "Uređaj se ne može dodijeliti nijednom korisniku.",
        "You cannot select an option with fewer users than the current project members.": "Ne možete odabrati opciju sa manje korisnika od trenutnog broja članova projekta.",
        "File check failed. Please download the latest template and try again.": "Provjera datoteke nije uspjela. Molimo preuzmite najnoviji predložak i pokušajte ponovo.",
        "Dynamic QR Code not active.": "Dinamički QR kod nije aktivan.",
        "Dynamic QR Code not enable.": "Dinamički QR kod nije omogućen.",
        "{0} not found.": "{0} nije pronađen.",
        "Tier charge plan": "Plan naplate po nivoima",
        "Feature billing charge plan new": "Funkcijski plan naplate nov",
        "Feature billing gradient charge plan": "Plan naplate funkcije po gradijentnom obračunu",
        "The exit time cannot be earlier than the entry time.": "Vrijeme izlaska ne može biti ranije od vremena ulaska.",
        "User Name or Password": "Korisničko ime ili lozinka",
        "You can only link up to 5 sites.": "Možete povezati najviše 5 lokacija.",
        "This license plate is already registered to a resident and cannot be added to the blocklist.": "Ova registarska tablica je već registrirana na stanara i ne može se dodati na crnu listu.",
        "This license plate is blocklisted and cannot be registered as a vehicle.": "Ova registarska tablica je na crnoj listi i ne može biti registrovana kao vozilo.",
        "Elevator not configured in company access floor.": "Lift nije konfiguriran na spratu pristupa kompanije.",
        "the device is not in the office": "Uređaj nije u uredu",
        "A maximum of 1000 data items can be imported": "Najviše se može uvesti 1000 stavki podataka",
        "Exit time cannot be later than the current time.": "Vrijeme izlaska ne može biti kasnije od trenutnog vremena.",
        "You can only import a file at a time in the current parking lot.": "Na trenutnom parkingu možete odjednom uvesti samo jednu datoteku.",
        "The license plate is already in the blocklist.": "Registarska tablica je već na crnoj listi.",
        "Building name too long.": "Naziv zgrade je predug.",
        "Unlock failed. Permission denied by user.": "Otključavanje nije uspjelo. Korisnik je odbio dozvolu.",
        "Please remove the sensor device(s) before disabling this feature.": "Molimo uklonite uređaj(e) senzora prije nego što onemogućite ovu funkciju.",
        "Operation failed! Daily limit of 15 records exceeded for this user.": "Operacija nije uspjela! Prekoračeno je dnevno ograničenje od 15 zapisa za ovog korisnika.",
        "A maximum of {0} public devices can be created within a single project. If you need to add more public devices, please contact Akuvox Technical Support at support@akuvox.com.": "Po projektu se može dodati najviše {0} javnih uređaja. Za dodavanje više uređaja kontaktirajte Akuvox tehničku podršku na support{'@'}akuvox.com.",
        "A maximum of {0} apartment devices can be created within a single project. If you need to add more apartment devices, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartment devices can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} buildings can be created within a single project. If you need to add more buildings, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} buildings can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} apartments can be created within a single project. If you need to add more apartments, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartments can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} residents can be created within a single project. If you need to add more residents, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} residents can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} delivery personnel can be created within a single project. If you need to add more delivery personnel, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} delivery personnel can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} access groups can be created within a single project. If you need to add more access groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} access groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} office groups can be created within a single project. If you need to add more office groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} office groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} admins can be created within a single project. If you need to add more admins, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} admins can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} companies can be created within a single project. If you need to add more companies, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} companies can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} personnel accounts can be created within a single project. If you need to add more personnel accounts, please contact Akuvox Technical Support at support@akuvox.com.": "Po projektu se može dodati najviše {0} korisničkih računa osoblja. Za dodavanje više kontaktirajte Akuvox tehničku podršku na support{'@'}akuvox.com.",
        "None": "Nijedan",
        "cancel": "Otkazi",


    }
};
